import React from 'react';
export function OffersFullWidthBanner() {
  return <div className="container mx-auto px-4" data-id="element-4593" data-mp="1z21a83p2jbdy">
      <a href="#" className="block bg-gray-300 rounded-xl overflow-hidden relative group transition-all" data-id="element-4594" data-mp="1bgdkv5ilh4od">
        <div className="w-full" style={{
        paddingTop: '21.43%'
      }} data-id="element-4595" data-mp="16i2amtoe0s5m"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-4596" data-mp="12i1n8jjb96mf">
          <div className="text-center text-gray-700" data-id="element-4597" data-mp="1z5prpyqg90ni">
            <div className="text-3xl md:text-4xl font-bold mb-2" data-id="element-4598" data-mp="1u7edzcx1a600">
              Full Width Promotional Banner
            </div>
            <div className="text-base md:text-lg" data-id="element-4599" data-mp="1pfd05mk7w77v">
              Exclusive offers and deals
            </div>
          </div>
        </div>
        <div className="absolute bottom-3 left-3 bg-black bg-opacity-60 text-white text-xs px-3 py-1.5 rounded" data-id="element-4600" data-mp="1lcqclxukx8gh">
          1400×300 — 4.67:1
        </div>
      </a>
    </div>;
}